import $ from 'jquery';
export default function initializeNavigationMobile() {

    //======================================================================================================
    // Menu öffnen beim Klick auf Hamburger
    //======================================================================================================
    $('.hamburg').click(function (e) {
        closeMobileNav();
    });

    $('.open-avu-messages-modal').click(function (e) {
        e.preventDefault();
        if($('body').hasClass("nav-mobile-is-open")) {
            closeMobileNav();
        }

    });
    $('.open-avu-problems-messages-modal').click(function (e) {
        e.preventDefault();
        if($('body').hasClass("nav-mobile-is-open")) {
            closeMobileNav();
        }

    });

    let closeMobileNav = function () {
        $('body').toggleClass("nav-mobile-is-open");
        if($(".hamburg").hasClass("checked")) {
            $(".hamburg").removeClass("checked")
        } else {
            $(".hamburg").addClass("checked");
        }
        if($(".avu-nav-collapse").hasClass("show")) {
            $(".avu-nav-collapse").removeClass("show");
        } else {
            $(".avu-nav-collapse").addClass("show");
        }
    }

    //level 0
    $('.current-menu-item').addClass('show');
    $('.current-menu-item > .submenu_level_1 ').addClass('show');
    $('.menu_level_0').click(function(event){
        event.stopPropagation();
        $(this).toggleClass('show');
        $(this).children('.submenu_level_1').toggleClass('show');
        $('.menu_level_0').not(this).each(function(){
            $(this).removeClass('show');
            $(this).children('.submenu_level_1').removeClass('show');
        });
    });
    //level 1
    $('.submenu_item_level_1').click(function(event){
            event.stopPropagation();
            $(this).toggleClass('show-color');
            $(this).children('.submenu_level_2').toggleClass('show');

            $('.submenu_item_level_1').not(this).each(function(){
                $(this).removeClass('show-color');
                $(this).children('.submenu_level_2').removeClass('show');
            });
    });
    $('.submenu_level_1').click(function(event){
        event.stopPropagation();
    });
    $('.submenu_level_2').click(function(event){
            event.stopPropagation();
    });
    $('.submenu_item_level_1.current-sub-menu-item > .submenu_level_2 ').addClass('show');
    $('.submenu_item_level_1.current-sub-menu-item').addClass('show-color');
    //level 2
    $('.current-sub-child-menu-item').each(function(){
        $(this).closest('.submenu_level_2').addClass('show');
        let grandparent = $(this).closest('.submenu_level_2').parent('.submenu_item_level_1');
        grandparent.addClass('current-sub-menu-item');
        grandparent.addClass('show-color');
    });
    $('.contact_private').click(function(event){
        $('.contact-is-for-private').removeClass('d-none');
        $('.contact-is-for-business').addClass('d-none');
    });
    $('.contact_business').click(function(event){
        $('.contact-is-for-private').addClass('d-none');
        $('.contact-is-for-business').removeClass('d-none');
    });








}